<div class="modal-header">
    <div class="modal-title">Connected to Quickbooks</div>
    <button type="button" class="close" id="qb-modal-close" aria-label="Close" (click)="decline()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <div class="row" *ngIf="forConnected">

        <p class="col-md-12 font-size-16">
            This report is linked to Quickbooks. <br>
            Connecting a report to Quickbooks is valid for 100 days. <br>
            You will need to renew your Quickbook connection on <strong>February 25, 2021.</strong>
        </p>

        <p class="col-md-12 font-size-16">
            Please select how often you want this report to be updated:
        </p>

        <div class="mb-15 radio__group ml-1">
            <label class="checkbox m-0 d-block">
                <input type="radio" name="customRadioInline" class="checkbox__input" [value]="true">
                <div class="checkbox__data">
                    <div class="checkbox__indicator"></div>
                    <p class="checkbox__text">
                        Monthly
                    </p>
                </div>
            </label>
            <label class="checkbox m-0 d-block">
                <input type="radio" name="customRadioInline" class="checkbox__input" [value]="false">
                <div class="checkbox__data">
                    <div class="checkbox__indicator"></div>
                    <p class="checkbox__text">
                        Quarterly
                    </p>
                </div>
            </label>
        </div>

        <p class="col-md-12 font-size-16">
            If you no longer want the report to be linked to Quickbooks, click the disconnect button.
        </p>

    </div>

    <div class="row" *ngIf="!forConnected">
        <p class="col-md-12 font-size-16">
            Connecting a report to Quickbooks is valid for 100 days.<br>
            Your Quickbook connection expired. <a class="font-weight-bold">Please update the connection.</a>
        </p>
    </div>
</div>

<div class="modal-footer">
    <button type="button" id="qb-modal-cancel" class="button secondary__button large__button"
        (click)="decline()">Cancel</button>
    <button type="button" id="qb-modal-continue" class="button primary__button large__button"
        (click)="confirm()">Disconnect Quickbooks</button>
</div>